module.exports = __webpack_public_path__ + "static/media/wardah_2.66552136.jpg";